import app from "../_app";
import {adpObserver} from "./adp";

const priceToggle = document.querySelector('.js-price-toggle');

export let updatePrices;

if(priceToggle) {
    let showPricesExcl = +localStorage.getItem('showPricesExcl');

    const priceToggleLabel = priceToggle.closest('.price-toggle');

    updatePrices = () => {
        const prices = [...document.querySelectorAll('.js-price')];
        const vatLabels = [...document.querySelectorAll('.js-price-vat-label')];
        const inclText = priceToggleLabel?.dataset.inclVat || 'Incl BTW';
        const exclText = priceToggleLabel?.dataset.exclVat || 'Excl BTW';

        prices.map(price => {
            if(showPricesExcl) {
                price.innerText = app.currency(price.dataset.price / 1.21);
            } else {
                price.innerText = app.currency(price.dataset.price);
            }
        });

        vatLabels.map(label => {
            const incl = label.dataset.inclVat || inclText;
            const excl = label.dataset.exclVat || exclText;
            label.innerText = showPricesExcl ? excl : incl;
        });

        return showPricesExcl;
    };

    const togglePricesHandler = ({currentTarget: {checked}}) => {
        showPricesExcl = +checked;
        localStorage.setItem('showPricesExcl', showPricesExcl);

        updatePrices();

        const productForm = document.querySelector('.js-product-form');

        if(productForm) {
            const productPrice = productForm.querySelector('.js-product-price');

            if (window.appikon && window.appikon.product && window.appikonDiscount && window.appikonDiscount.loadProductPageApi) {
                adpObserver.observe(productForm, {childList: true});

                window.appikon.product.variant_price = showPricesExcl ? productPrice.dataset.price / 1.21 : productPrice.dataset.price;
                window.appikonDiscount.loadProductPageApi();
            }
        }
    };

    if(showPricesExcl) {
        priceToggle.checked = true;
        updatePrices();
    }

    priceToggle.addEventListener('click', togglePricesHandler);
}
